import * as React from "react";

import { useAsyncEffect, useInterval } from "../";
import { infoService, telemetryService } from "../../modules";
import { useRelodeApp } from "../RelodeApp";
import { FeatureToggle } from "./../../domain";
import { AppVersionCheckerDialog } from "./appVersionCheckerDialog";

interface AppVersionCheckerProps {
    useAppName?: boolean;
}

export const AppVersionChecker = (props: AppVersionCheckerProps) => {
    const { useAppName = true } = props;

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [currentVersion, setCurrentVersion] = React.useState(
        appConfig.buildNumber
    );
    const [checkForUpdates, setCheckForUpdates] = React.useState(true);
    const {
        actions: relodeAppActions,
        state: { haltApiCalls },
    } = useRelodeApp();

    const intervalCheck = () => setCheckForUpdates(true);

    const asyncCheck = async () => {
        if (haltApiCalls || !checkForUpdates || dialogOpen) return;

        try {
            const newAppConfig = await infoService.getAppConfig();

            if (!!newAppConfig && currentVersion !== newAppConfig.build) {
                setCurrentVersion(newAppConfig.build);
                FeatureToggle.setFeatures(newAppConfig.featureToggles);
                // **** DO NOT COMMENT THIS OUT. ****
                // set your .local file's REACT_APP_CHECK_VERSION_UPDATE_MS param to be a huge number
                setDialogOpen(true);
            }
            relodeAppActions.apiCallSuccess();
            setCheckForUpdates(false);
        } catch (err) {
            relodeAppActions.apiCallFailure();
            telemetryService.trackEvent("InfoService:getAppConfig:error", {
                message: JSON.stringify(err),
            });
        }
    };

    useInterval(intervalCheck, appConfig.checkVersionUpdateMs);
    useAsyncEffect(asyncCheck, [checkForUpdates]);

    const handleRefresh = () => {
        setDialogOpen(false);
        window.location.reload();
    };

    return dialogOpen ? (
        <AppVersionCheckerDialog
            open={true}
            onRefresh={handleRefresh}
            appName={useAppName ? appConfig.appName : null}
        />
    ) : null;
};
